// extracted by mini-css-extract-plugin
module.exports = {"main":"HeroCheckmarks_main__2l8fn","checkItems":"HeroCheckmarks_checkItems__1_qH1","checkItem":"HeroCheckmarks_checkItem__1094V","checkIcon":"HeroCheckmarks_checkIcon__1zGkC"};